module.exports = __webpack_public_path__ + "img/addressBook.3cae1649.png";